import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=51d5dfc2&"
import script from "./SupportPage.vue?vue&type=script&lang=js&"
export * from "./SupportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports